/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import { fillerMap } from '../../../../../options';
import ControllersGroup from '../../../controllers/ControllersGroup';
import SelectTips from '../../../../core/SelectTips';
import {
  ToggleSwitchController,
  SelectController,
  CustomSortController,
  ChoiceBoxController,
  InputLineController,
} from '../../../controllers/Base';

const generalControllersDefaultPropHandle = () => {};
const generalControllersDefaultPropSetExtend = () => {};

const GeneralControllers = ({
  handle = generalControllersDefaultPropHandle,
  config = undefined,
  data = undefined,
  extend = '',
  setExtend = generalControllersDefaultPropSetExtend,
  selectedLine = undefined,
  selectedLineMap = undefined,
  selectedColumn = undefined,
  selectedColumnMap = undefined,
  selectedFunction = undefined,
  forDrilldown = false,
}) => {
  const totalsLabel = () => {
    if (config?.TotalFunctionControl) {
      return config.TotalFunctionControl === 'avg' ? 'médias' : 'totais';
    }
    return selectedFunction?.value === 'mean' ? 'médias' : 'totais';
  };

  return (
    <>
      <ControllersGroup
        title="Opções Gerais"
        id="general"
        extend={extend}
        setExtend={setExtend}
        sizeIncrease={(
          config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0
        ) + (
          config?.SortColumnsControl === 'Customizado' ? data?.columns?.length : 0
        )}
      >
        {(data?.columns || []).filter((item) => {
          const fItem = typeof item === 'string' ? item : item[item.length - 1];
          return fItem !== 'Totais';
        }).length > 1 && (
          <>
            <SelectController
              label="Ordenar colunas"
              handle={handle}
              kWord="SortColumnsControl"
              options={[
                { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
                { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
                { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
                ...(forDrilldown ? [] : [{ label: 'Customizado', value: 'Customizado', id: 'Customizado' }]),
              ]}
              configValue={config?.SortColumnsControl}
              fullWidth
            />
            {config?.SortColumnsControl === 'Customizado' && (
              <CustomSortController
                handle={handle}
                kWord="CustomSortColumnControl"
                oldOrder={data?.columns || []}
                newOrder={config?.CustomSortColumnControl?.kpiCategories || []}
                removeTotal
              />
            )}
          </>
        )}
        {selectedLine && (
          <SelectController
            label="Ordenar campos"
            handle={handle}
            kWord="SortValuesControl"
            options={[
              { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
              { label: 'Crescente', value: 'Crescente', id: 'Crescente' },
              { label: 'Decrescente', value: 'Decrescente', id: 'Decrescente' },
              ...(forDrilldown ? [] : [{ label: 'Customizado', value: 'Customizado', id: 'Customizado' }]),
            ]}
            configValue={config?.SortValuesControl}
            fullWidth
          />
        )}
        {config?.SortValuesControl !== 'Customizado' && config?.SortValuesControl !== 'Não ordenado' && (
          <SelectController
            label="Coluna a ser ordenada"
            handle={handle}
            kWord="ColumnToSortControl"
            options={[
              { label: 'Linha (-)', value: 'index', id: 'sort-index' },
              ...data?.columns?.map((col) => {
                const val = typeof col === 'string' ? col : col[col.length - 1];
                return { label: val, value: val.toString(), id: `sort-${val}` };
              }),
            ]}
            // Replace to fix legacy values
            configValue={(config?.ColumnToSortControl || 'index').replace(/.*,/, '')}
            fullWidth
          />
        )}
        {config?.SortValuesControl === 'Customizado' && (
          <CustomSortController
            handle={handle}
            kWord="CustomSortControlUpt"
            oldOrder={data?.index || []}
            newOrder={config?.CustomSortControl?.kpiCategories || []}
            removeTotal
          />
        )}
        <ToggleSwitchController
          label={`Linha de ${totalsLabel()}`}
          handle={handle}
          kWord="LineShowTotalControl"
          configValue={config?.LineShowTotalControl}
          firstOption=""
          secondOption=""
          disabled={config?.LineOnlyShowTotalControl}
        />
        <ToggleSwitchController
          label="Ocultar outras linhas"
          handle={handle}
          kWord="LineOnlyShowTotalControl"
          configValue={config?.LineOnlyShowTotalControl}
          firstOption=""
          secondOption=""
          disabled={!config?.LineShowTotalControl}
        />
        {data?.columns?.length > 1 && (
          <>
            <ToggleSwitchController
              label={`Coluna de ${totalsLabel()}`}
              handle={handle}
              kWord="ColumnShowTotalControl"
              configValue={config?.ColumnShowTotalControl}
              firstOption=""
              secondOption=""
              disabled={config?.ColumnOnlyShowTotalControl}
            />
            <ToggleSwitchController
              label="Ocultar outras colunas"
              handle={handle}
              kWord="ColumnOnlyShowTotalControl"
              configValue={config?.ColumnOnlyShowTotalControl}
              firstOption=""
              secondOption=""
              disabled={!config?.ColumnShowTotalControl}
            />
          </>
        )}
        <ChoiceBoxController
          label="Fórmula"
          handle={handle}
          kWord="TotalFunctionControl"
          options={[
            { value: 'avg', label: 'Média dos valores', id: 'totalsAvg' },
            { value: 'sum', label: 'Soma dos valores', id: 'totalsSum' },
          ]}
          configValue={config?.TotalFunctionControl ?? (selectedFunction?.value === 'mean' ? 'avg' : 'sum')}
          fullWidth
          disabled={
            !config?.LineShowTotalControl && (!selectedColumn || !config?.ColumnShowTotalControl)
          }
        />
        <ToggleSwitchController
          label="Mínimo considerável"
          handle={handle}
          kWord="MinValueControl2"
          configValue={config?.MinValueControl?.checked}
          firstOption="Automático"
          secondOption="Manual"
          secondColor="secondary"
        />
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            width: 'calc(50% - 5px)',
          }}
        >
          <InputLineController
            isNumber
            precision={2}
            label=""
            handle={handle}
            kWord="MinValue"
            configValue={config?.MinValueControl?.value}
            disabled={config?.MinValueControl?.checked}
            fullWidth
          />
          <SelectTips
            style={{
              position: 'absolute',
              right: '0',
              top: '0',
            }}
            description="O valor mínimo a ser considerado no cálculo da fórmula"
          />
        </div>
        <ToggleSwitchController
          label="Máximo considerável"
          handle={handle}
          kWord="MaxValueControl2"
          configValue={config?.MaxValueControl?.checked}
          firstOption="Automático"
          secondOption="Manual"
          secondColor="secondary"
        />
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            width: 'calc(50% - 5px)',
          }}
        >
          <InputLineController
            isNumber
            precision={2}
            label=""
            handle={handle}
            kWord="MaxValue"
            configValue={config?.MaxValueControl?.value}
            disabled={config?.MaxValueControl?.checked}
          />
          <SelectTips
            style={{
              position: 'absolute',
              right: '0',
              top: '0',
            }}
            description="O valor máximo a ser considerado no cálculo da fórmula"
          />
        </div>
        {selectedLine?.type === 'datetime64[ns]' && selectedLineMap?.value in fillerMap && (
          <ToggleSwitchController
            label="Preencher datas faltantes na linha"
            handle={handle}
            kWord={`ExtendDateLine-${selectedLineMap?.value ?? 'none'}`}
            configValue={config?.ExtendDateLine}
            firstOption=""
            secondOption=""
            fullWidth
          />
        )}
        {selectedColumn?.type === 'datetime64[ns]' && selectedColumnMap?.value in fillerMap && (
          <ToggleSwitchController
            label="Preencher datas faltantes na coluna"
            handle={handle}
            kWord={`ExtendDateColumn-${selectedColumnMap?.value ?? 'none'}`}
            configValue={config?.ExtendDateColumn}
            firstOption=""
            secondOption=""
            fullWidth
          />
        )}
        <ChoiceBoxController
          label="Dados primários"
          handle={handle}
          kWord="DataFormat"
          configValue={config?.DataFormat}
          options={[
            { value: 'absolute', label: 'Absoluto', id: 'absolute' },
            { value: 'percentual', label: 'Percentual', id: 'percentual' },
          ]}
          fullWidth
        />
        {config?.DataFormat === 'absolute' && (
          <ChoiceBoxController
            label="Formato absoluto"
            handle={handle}
            kWord="DataAbsoluteFormat"
            configValue={config?.DataAbsoluteFormat}
            options={[
              { label: 'Número', value: 'number', id: 'number' },
              { label: 'Duração', value: 'duration', id: 'duration' },
            ]}
            fullWidth
          />
        )}
        {config?.DataFormat === 'percentual' && data?.columns?.length > 1 && (
          <ChoiceBoxController
            label="Formato percentual"
            handle={handle}
            kWord="DataPercentFormat"
            configValue={config?.DataPercentFormat}
            options={[
              { label: 'Global', value: 'global', id: 'global' },
              { label: 'Por linhas', value: 'byRow', id: 'byRow' },
              { label: 'Por colunas', value: 'byColumn', id: 'byColumn' },
            ]}
            fullWidth
          />
        )}

        <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />

        <ChoiceBoxController
          label="Dados secundários"
          handle={handle}
          kWord="DataFormatAlt"
          configValue={config?.DataFormatAlt}
          options={[
            { value: 'none', label: 'Nenhum', id: 'none' },
            { value: 'absolute', label: 'Absoluto', id: 'absolute' },
            { value: 'percentual', label: 'Percentual', id: 'percentual' },
          ]}
          fullWidth
        />
        {config?.DataFormatAlt === 'absolute' && (
          <ChoiceBoxController
            label="Formato absoluto"
            handle={handle}
            kWord="DataAbsoluteFormatAlt"
            configValue={config?.DataAbsoluteFormatAlt}
            options={[
              { label: 'Número', value: 'number', id: 'number' },
              { label: 'Duração', value: 'duration', id: 'duration' },
            ]}
            fullWidth
          />
        )}
        {config?.DataFormatAlt === 'percentual' && (
          <ChoiceBoxController
            label="Formato percentual"
            handle={handle}
            kWord="DataPercentFormatAlt"
            configValue={
              !['global', 'variation'].includes(config?.DataPercentFormatAlt) && data?.columns?.length <= 1
                ? 'global' : config?.DataPercentFormatAlt
            }
            options={[
              { label: 'Global', value: 'global', id: 'global' },
              { label: 'Por linhas', value: 'byRow', id: 'byRow' },
              { label: 'Por colunas', value: 'byColumn', id: 'byColumn' },
            ]}
            fullWidth
          />
        )}
        {(
          (config?.DataFormat === 'absolute' && config?.DataAbsoluteFormat === 'duration')
          || (config?.DataFormatAlt === 'absolute' && config?.DataAbsoluteFormatAlt === 'duration')
        ) && (
          <>
            <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />
            <ChoiceBoxController
              label="Unidade original"
              handle={handle}
              kWord="DurationUnit"
              configValue={config?.DurationUnit}
              options={[
                { label: 'Dias', value: 'days', id: 'days' },
                { label: 'Horas', value: 'hours', id: 'hours' },
                { label: 'Minutos', value: 'minutes', id: 'minutes' },
                { label: 'Segundos', value: 'seconds', id: 'seconds' },
              ]}
              fullWidth
            />
          </>
        )}
      </ControllersGroup>
    </>
  );
};

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.objectOf(PropTypes.any),
  selectedLineMap: PropTypes.objectOf(PropTypes.any),
  selectedColumn: PropTypes.objectOf(PropTypes.any),
  selectedColumnMap: PropTypes.objectOf(PropTypes.any),
  selectedFunction: PropTypes.objectOf(PropTypes.any),
  forDrilldown: PropTypes.bool,
};

export default GeneralControllers;
